export const CONTENT = {
  ro: {
    nav: {
      links: [
        { label: "Cursuri", href: "#limbi" },
        { label: "Metodă", href: "#metoda" },
        { label: "Despre", href: "#despre" },
        { label: "Contact", href: "#contact" },
      ],
      cta: "Programează-te",
    },
    hero: {
      eyebrow: "Iris Languages Academy · Online, oriunde în lume",
      lines: [
        { text: "Limbi noi," },
        { text: "oportunități noi," },
        { pre: "un viitor ", em: "fără bariere." },
      ],
      sub: "A Rainbow of Languages, A World of Connections. Cursuri de neerlandeză, engleză, română, germană și franceză — online, individual sau în grup, construite în jurul ritmului și obiectivelor tale.",
      ctaPrimary: "Programează o lecție",
      ctaSecondary: "Descoperă cursurile",
      chip: "Prețuri de la 85 lei / persoană",
      card: { title: "100% online", sub: "Individual sau în grup" },
    },
    marquee: {
      items: [
        "A Rainbow of Languages",
        "A World of Connections",
        "Limbi noi, oportunități noi",
        "Un viitor fără bariere",
      ],
    },
    about: {
      eyebrow: "Pasiunea din spatele academiei",
      title: "Un pod între limbi, un curcubeu între culturi.",
      p1: "Pasiunea pentru limbi străine a început încă din copilărie și a devenit, în timp, o parte importantă din identitatea și parcursul meu profesional. Sunt de origine română și trăiesc în Belgia, unde am descoperit cât de importantă este comunicarea într-o lume multiculturală.",
      p2: "Sunt studentă la KU Leuven, una dintre universitățile de prestigiu din lume, clasată în top 60 la nivel mondial. Într-o țară cu trei limbi oficiale — neerlandeză, franceză și germană — și cu engleza atât de prezentă în mediul internațional, am învățat rapid să comunic între culturi.",
      p3: "Am acumulat experiență în mediul profesional, colaborând cu o companie multinațională din domeniul limbilor străine. Am înțeles că fiecare persoană are propriul ritm, propriile obiective și propriul stil de învățare — iar această diversitate stă la baza metodei mele.",
      badges: [
        "Studentă la KU Leuven · top 60 mondial",
        "3 limbi naționale + engleză",
        "Experiență într-o multinațională de limbi străine",
      ],
      badgeIcons: ["graduation", "languages", "briefcase"],
      quote: "Fiecare limbă învățată deschide o ușă către o nouă cultură, o nouă experiență și noi oportunități.",
      badgeKU: "KU Leuven",
      badgeKUSub: "Top 60 mondial",
    },
    languages: {
      eyebrow: "Cursurile noastre",
      title: "Un curcubeu de limbi, o singură pasiune.",
      dutch: {
        code: "NL",
        title: "Neerlandeză (olandeză)",
        tag: "Pentru români și pentru toți",
        desc: "Cursuri de neerlandeză pentru români și pentru toate persoanele care își doresc să învețe această limbă, indiferent de motiv. Lecțiile sunt disponibile online, individual sau în grup, în funcție de preferințele tale.",
        bullets: [
          "Pentru plăcerea de a învăța o limbă nouă",
          "Dezvoltare profesională și oportunități de muncă",
          "Pregătire pentru mutarea în Belgia sau Olanda",
          "Integrare, comunicare și viața de zi cu zi",
        ],
      },
      others: [
        { code: "EN", title: "Engleză", desc: "Pentru carieră, studii, călătorii și mediul internațional." },
        { code: "RO", title: "Română", sub: "pentru expați și vorbitori străini", desc: "Pentru expați și pentru toți cei care vor să învețe limba română." },
        { code: "DE", title: "Germană", desc: "Pentru studii, muncă, călătorii sau relocare." },
        { code: "FR", title: "Franceză", desc: "Pentru carieră, călătorii sau pur și simplu din pasiune." },
      ],
      footnote: "Indiferent de motiv — carieră, călătorii, studii, relocare sau pasiune — te ajutăm să faci progrese pas cu pas.",
    },
    method: {
      eyebrow: "Cum funcționează",
      title: "O metodă adaptată ție.",
      intro: "Nu există o metodă universală de învățare. De aceea adaptez lecțiile în funcție de nivelul, nevoile și obiectivele fiecărui cursant — student, angajat, expat sau în pregătire pentru o mutare în străinătate.",
      intro2: "Lecțiile sunt structurate în capitole tematice, construite progresiv, în care îmbinăm gramatica și vocabularul, pas cu pas. Pun accent pe explicații clare, exemple practice și situații reale de comunicare.",
      steps: [
        { t: "Individual sau în grup", d: "Alegi formatul care ți se potrivește, în funcție de preferințele tale." },
        { t: "100% online", d: "Lecțiile au loc online, de oriunde din lume." },
        { t: "Test inițial de nivel", d: "Dacă dorești, stabilim împreună punctul de plecare." },
        { t: "Plan personalizat", d: "Capitole tematice, construite progresiv, în jurul obiectivelor tale." },
        { t: "Materiale și exerciții", d: "Explicații clare, exemple practice și exerciții între lecții." },
        { t: "Progres urmărit pas cu pas", d: "Feedback constant, ca să comunici natural și cu încredere." },
      ],
    },
    pricing: {
      eyebrow: "Prețuri",
      from: "de la",
      amount: "85 lei",
      unit: "/ persoană",
      desc: "Prețuri începând de la 85 lei / persoană, pentru lecții online individuale sau în grup. Spune-ne ce limbă vrei să înveți și îți pregătim o ofertă adaptată nevoilor tale.",
      chips: ["Lecții online", "Individual sau în grup", "Toate limbile"],
      cta: "Contactează-ne",
    },
    contact: {
      eyebrow: "Contact",
      title: "Ești gata să începi să înveți o limbă nouă?",
      sub: "Te așteptăm cu drag la Iris Languages Academy! Scrie-ne ce limbă vrei să înveți și îți răspundem personal.",
      whatsapp: "Scrie-ne pe WhatsApp",
      email: "Trimite-ne un email",
      formTitle: "Sau lasă-ne un mesaj",
      name: "Nume",
      namePh: "Numele tău",
      emailLabel: "Email",
      emailPh: "adresa@email.com",
      language: "Ce limbă vrei să înveți?",
      format: "Format preferat",
      formats: ["Individual", "În grup", "Nu știu încă"],
      message: "Mesaj",
      messagePh: "Spune-ne câteva vorbe despre tine și obiectivele tale…",
      submit: "Trimite mesajul",
      sending: "Se trimite…",
      success: "Mesaj trimis! Îți răspundem cât de curând.",
      error: "Ups, ceva n-a mers. Încearcă din nou sau scrie-ne pe WhatsApp.",
      languageOptions: ["Neerlandeză", "Engleză", "Română", "Germană", "Franceză", "Nu știu încă"],
    },
    footer: {
      tagline: "Limbi noi, oportunități noi, un viitor fără bariere!",
      closing: "A bridge between languages, a rainbow between cultures.",
      explore: "Explorează",
      contact: "Contact",
      rights: "Toate drepturile rezervate.",
    },
  },
  en: {
    nav: {
      links: [
        { label: "Courses", href: "#limbi" },
        { label: "Method", href: "#metoda" },
        { label: "About", href: "#despre" },
        { label: "Contact", href: "#contact" },
      ],
      cta: "Book a lesson",
    },
    hero: {
      eyebrow: "Iris Languages Academy · Online, anywhere in the world",
      lines: [
        { text: "New languages," },
        { text: "new opportunities," },
        { pre: "a future ", em: "without barriers." },
      ],
      sub: "A Rainbow of Languages, A World of Connections. Dutch, English, Romanian, German and French courses — online, one-on-one or in groups, built around your rhythm and your goals.",
      ctaPrimary: "Book a lesson",
      ctaSecondary: "Discover the courses",
      chip: "Prices from 85 lei / person",
      card: { title: "100% online", sub: "One-on-one or in groups" },
    },
    marquee: {
      items: [
        "A Rainbow of Languages",
        "A World of Connections",
        "New languages, new opportunities",
        "A future without barriers",
      ],
    },
    about: {
      eyebrow: "The passion behind the academy",
      title: "A bridge between languages, a rainbow between cultures.",
      p1: "My passion for foreign languages began in childhood and grew into an important part of who I am and of my professional path. I am Romanian by origin and live in Belgium, where I discovered how essential communication is in a multicultural world.",
      p2: "I am a student at KU Leuven, one of the world's most prestigious universities, ranked in the global top 60. In a country with three official languages — Dutch, French and German — and with English so present in international life, I quickly learned to move between cultures.",
      p3: "I gained professional experience collaborating with a multinational company in the language field. I understood that every person has their own rhythm, goals and learning style — and this diversity is the foundation of my teaching method.",
      badges: [
        "KU Leuven student · top 60 worldwide",
        "3 national languages + English",
        "Experience at a multinational language company",
      ],
      badgeIcons: ["graduation", "languages", "briefcase"],
      quote: "Every language you learn opens a door to a new culture, a new experience and new opportunities.",
      badgeKU: "KU Leuven",
      badgeKUSub: "Top 60 worldwide",
    },
    languages: {
      eyebrow: "Our courses",
      title: "A rainbow of languages, one single passion.",
      dutch: {
        code: "NL",
        title: "Dutch",
        tag: "For Romanians and everyone",
        desc: "Dutch courses for Romanians and for everyone who wants to learn this language, whatever the reason. Lessons are available online, one-on-one or in groups, depending on your preference.",
        bullets: [
          "For the joy of learning a new language",
          "Professional development and job opportunities",
          "Preparing for a move to Belgium or the Netherlands",
          "Integration, communication and everyday life",
        ],
      },
      others: [
        { code: "EN", title: "English", desc: "For career, studies, travel and the international world." },
        { code: "RO", title: "Romanian", sub: "for expats and foreign speakers", desc: "For expats and everyone who wants to learn Romanian." },
        { code: "DE", title: "German", desc: "For studies, work, travel or relocation." },
        { code: "FR", title: "French", desc: "For career, travel or simply out of passion." },
      ],
      footnote: "Whatever the reason — career, travel, studies, relocation or passion — we help you make progress step by step.",
    },
    method: {
      eyebrow: "How it works",
      title: "A method adapted to you.",
      intro: "There is no universal way to learn a language. That is why I adapt each lesson to the level, needs and goals of every student — whether you are a student, an employee, an expat or preparing for a move abroad.",
      intro2: "Lessons are structured into thematic chapters, built progressively, combining grammar and vocabulary step by step. I put emphasis on clear explanations, practical examples and real communication situations.",
      steps: [
        { t: "One-on-one or in groups", d: "You choose the format that suits you best." },
        { t: "100% online", d: "Lessons take place online, from anywhere in the world." },
        { t: "Initial level test", d: "If you wish, we establish your starting point together." },
        { t: "Personalised plan", d: "Thematic chapters, built progressively around your goals." },
        { t: "Materials & exercises", d: "Clear explanations, practical examples and exercises between lessons." },
        { t: "Progress tracked step by step", d: "Constant feedback, so you communicate naturally and confidently." },
      ],
    },
    pricing: {
      eyebrow: "Pricing",
      from: "from",
      amount: "85 lei",
      unit: "/ person",
      desc: "Prices starting from 85 lei / person for online lessons, one-on-one or in groups. Tell us which language you want to learn and we will prepare an offer adapted to your needs.",
      chips: ["Online lessons", "One-on-one or in groups", "All languages"],
      cta: "Contact us",
    },
    contact: {
      eyebrow: "Contact",
      title: "Ready to start learning a new language?",
      sub: "We look forward to welcoming you at Iris Languages Academy! Tell us which language you want to learn and we will answer personally.",
      whatsapp: "Message us on WhatsApp",
      email: "Send us an email",
      formTitle: "Or leave us a message",
      name: "Name",
      namePh: "Your name",
      emailLabel: "Email",
      emailPh: "you@email.com",
      language: "Which language do you want to learn?",
      format: "Preferred format",
      formats: ["One-on-one", "Group", "Not sure yet"],
      message: "Message",
      messagePh: "Tell us a few words about yourself and your goals…",
      submit: "Send your message",
      sending: "Sending…",
      success: "Message sent! We will get back to you soon.",
      error: "Oops, something went wrong. Try again or reach us on WhatsApp.",
      languageOptions: ["Dutch", "English", "Romanian", "German", "French", "Not sure yet"],
    },
    footer: {
      tagline: "New languages, new opportunities, a future without barriers!",
      closing: "A bridge between languages, a rainbow between cultures.",
      explore: "Explore",
      contact: "Contact",
      rights: "All rights reserved.",
    },
  },
};
